import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addtopValidation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import {
  createTopUp,
  getSingleTopUpbyId,
  updateTopUp,
} from "../../../redux/topup/actions";

const UpdateTopUp = () => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const singleMembership = useSelector(
    (state) => state?.reusableSlice?.singlePopUp
  );

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getSingleTopUpbyId(id));
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: singleMembership?.title || "",
      ar_title: singleMembership?.ar_title || "",
      max_invoices: singleMembership?.max_invoices || "",
      max_invoices1: singleMembership?.max_invoices1 || "",
      max_invoices2: singleMembership?.max_invoices2 || "",
       max_invoices3: singleMembership?.max_invoices3 || "",
      max_invoices4: singleMembership?.max_invoices4 || "",
      price: singleMembership?.price || 0,
      status: singleMembership?.status || 0,
    },
    validationSchema: addtopValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      parent_id: 1,
      id: singleMembership?.id,
    };
    dispatch(updateTopUp(data, setLoading, navigate));
  };

  const statusoptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "Inactive" },
    { value: 4, label: "Block" },
  ];

  return (
    <div className="p-3">
      <h3 className="pb-3">Update Top-Up</h3>
      <div className=" category-wrapper">
        <p className="bredcrumbs">
        <a onClick={()=>navigate("/")} >Home &gt;</a> <a onClick={()=>navigate("/topuplist")} >Add-ons &gt;</a>Update
          Add-On
        </p>
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            <div className="col-md-5">
              <div className="col-md-12 form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>

              <div className="col-md-12 form-group">
                <label>Ar Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Price (SAR)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter price"
                  name="price"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.price}
                />
                {formik.touched.price && formik.errors.price ? (
                  <div className="error">{formik.errors.price}</div>
                ) : null}
              </div>

              <div className="col-md-12 form-group" xs={4}>
                <label>Status</label>
                <div>
                  <ReactSelect
                    value={statusoptions.find(
                      (option) => option.value === formik.values.status
                    )}
                    placeholder="Select Status"
                    id="status"
                    name="status"
                    options={statusoptions}
                    onChange={(selectedOption) =>
                      formik.setFieldValue("status", selectedOption.value)
                    }
                    onBlur={() => formik.setFieldTouched("status", true)}
                  />
                  {formik.touched.status && formik.errors.status ? (
                    <div className="error">{formik.errors.status}</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className=" col-md-7 d-flex justify-content-center">
              <div className="table-responsive  ">
                <table className="table">
                  <thead>
                    <th>Invoice Type</th>
                    <th>Limited Number</th>
                    <th>Unlimited Number</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Simplified</td>
                      <td>
                        {formik.values.max_invoices !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices &&
                                formik.errors.max_invoices
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices}
                            />
                            {formik.touched.max_invoices &&
                              formik.errors.max_invoices && (
                                <div className="error">
                                  {formik.errors.max_invoices}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices === 10000}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>VAT</td>
                      <td>
                        {formik.values.max_invoices1 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices1 &&
                                formik.errors.max_invoices1
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices1"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices1}
                            />
                            {formik.touched.max_invoices1 &&
                              formik.errors.max_invoices1 && (
                                <div className="error">
                                  {formik.errors.max_invoices1}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices1",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices1 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Purchase</td>
                      <td>
                        {formik.values.max_invoices2 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices2"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices2}
                            />
                            {formik.touched.max_invoices2 &&
                              formik.errors.max_invoices2 && (
                                <div className="error">
                                  {formik.errors.max_invoices2}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices2",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices2 === 10000}
                        />
                      </td>
                    </tr>
                       <tr>
                      <td>Credit Notes</td>
                      <td>
                        {formik.values.max_invoices3 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter credit note..."
                              name="max_invoices3"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices3}
                            />
                            {formik.touched.max_invoices3 &&
                              formik.errors.max_invoices3 && (
                                <div className="error">
                                  {formik.errors.max_invoices3}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices3",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices3 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Debit Notes</td>
                      <td>
                        {formik.values.max_invoices4 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter debit note..."
                              name="max_invoices4"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices4}
                            />
                            {formik.touched.max_invoices4 &&
                              formik.errors.max_invoices4 && (
                                <div className="error">
                                  {formik.errors.max_invoices4}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices4",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices4 === 10000}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              onClick={() => {
                navigate(-1);
              }}
              type="button"
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
              disabled={loading}
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateTopUp;
